import React, { useState } from 'react';
import { PencilIcon, TrashIcon, EyeIcon, PlusCircleIcon, SearchIcon, FilterIcon } from 'lucide-react';
import { allProperties } from '../../utils/mockData';
import { useNavigate } from 'react-router-dom';
const AdminPropertyList = ({
  onEditProperty,
  onAddNewProperty
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState('all');
  const navigate = useNavigate();
  // Filter properties based on search term and property type
  const filteredProperties = allProperties.filter(property => {
    const matchesSearch = property.title.toLowerCase().includes(searchTerm.toLowerCase()) || property.location.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesType = filterType === 'all' || property.propertyType === filterType;
    return matchesSearch && matchesType;
  });
  const handleViewProperty = id => {
    navigate(`/property/${id}`);
  };
  return <div className="bg-white rounded-lg shadow" data-id="element-267">
      {/* Header with actions */}
      <div className="p-6 border-b border-gray-200 flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0" data-id="element-268">
        <div className="flex items-center space-x-3" data-id="element-269">
          <div className="relative" data-id="element-270">
            <SearchIcon className="h-5 w-5 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2" data-id="element-271" />
            <input type="text" placeholder="Search properties..." className="pl-10 pr-4 py-2 border rounded-md focus:ring-[#006D77] focus:border-[#006D77] w-full sm:w-64" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-272" />
          </div>
          <div className="relative" data-id="element-273">
            <FilterIcon className="h-5 w-5 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2" data-id="element-274" />
            <select className="pl-10 pr-4 py-2 border rounded-md focus:ring-[#006D77] focus:border-[#006D77] appearance-none bg-white" value={filterType} onChange={e => setFilterType(e.target.value)} data-id="element-275">
              <option value="all" data-id="element-276">All Types</option>
              <option value="bnb" data-id="element-277">Bed & Breakfast</option>
              <option value="farmstay" data-id="element-278">Farmstay</option>
            </select>
          </div>
        </div>
        <button onClick={onAddNewProperty} className="bg-[#006D77] hover:bg-[#005a63] text-white px-4 py-2 rounded-md flex items-center" data-id="element-279">
          <PlusCircleIcon className="h-5 w-5 mr-2" data-id="element-280" />
          Add New Property
        </button>
      </div>
      {/* Property list */}
      <div className="overflow-x-auto" data-id="element-281">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-282">
          <thead className="bg-gray-50" data-id="element-283">
            <tr data-id="element-284">
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-285">
                Property
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-286">
                Location
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-287">
                Type
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-288">
                Price
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-289">
                Rating
              </th>
              <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-290">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-291">
            {filteredProperties.map(property => <tr key={property.id} className="hover:bg-gray-50" data-id="element-292">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-293">
                  <div className="flex items-center" data-id="element-294">
                    <div className="h-10 w-10 rounded-md overflow-hidden flex-shrink-0" data-id="element-295">
                      <img src={property.images[0]} alt={property.title} className="h-full w-full object-cover" data-id="element-296" />
                    </div>
                    <div className="ml-4" data-id="element-297">
                      <div className="text-sm font-medium text-gray-900 line-clamp-1" data-id="element-298">
                        {property.title}
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-299">
                        ID: {property.id}
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-300">
                  {property.location}
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-301">
                  <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${property.propertyType === 'bnb' ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800'}`} data-id="element-302">
                    {property.propertyType === 'bnb' ? 'Bed & Breakfast' : 'Farmstay'}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-303">
                  ${property.pricePerNight}/night
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-304">
                  <div className="flex items-center" data-id="element-305">
                    <span className="text-sm text-gray-900 mr-1" data-id="element-306">
                      {property.rating}
                    </span>
                    <span className="text-xs text-gray-500" data-id="element-307">
                      ({property.reviewCount})
                    </span>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-308">
                  <button onClick={() => handleViewProperty(property.id)} className="text-gray-500 hover:text-gray-700 mr-3" data-id="element-309">
                    <EyeIcon className="h-5 w-5" data-id="element-310" />
                  </button>
                  <button onClick={() => onEditProperty(property)} className="text-blue-500 hover:text-blue-700 mr-3" data-id="element-311">
                    <PencilIcon className="h-5 w-5" data-id="element-312" />
                  </button>
                  <button className="text-red-500 hover:text-red-700" data-id="element-313">
                    <TrashIcon className="h-5 w-5" data-id="element-314" />
                  </button>
                </td>
              </tr>)}
          </tbody>
        </table>
        {filteredProperties.length === 0 && <div className="text-center py-10" data-id="element-315">
            <p className="text-gray-500" data-id="element-316">
              No properties found matching your criteria
            </p>
          </div>}
      </div>
      {/* Pagination */}
      <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between" data-id="element-317">
        <div className="text-sm text-gray-500" data-id="element-318">
          Showing{' '}
          <span className="font-medium" data-id="element-319">{filteredProperties.length}</span> of{' '}
          <span className="font-medium" data-id="element-320">{allProperties.length}</span> properties
        </div>
        <div className="flex items-center space-x-2" data-id="element-321">
          <button className="px-3 py-1 border rounded text-sm disabled:opacity-50" data-id="element-322">
            Previous
          </button>
          <button className="px-3 py-1 bg-[#006D77] text-white rounded text-sm" data-id="element-323">
            1
          </button>
          <button className="px-3 py-1 border rounded text-sm" data-id="element-324">Next</button>
        </div>
      </div>
    </div>;
};
export default AdminPropertyList;